<section>
  <app-contact-reason-filter
    (filterEmmiter)="setFilter($event)"
  ></app-contact-reason-filter>
  <app-contact-reason-list [filter]="filter"></app-contact-reason-list>
</section>
